export type TimingRecord = {
    name:string,
    meta:Record<string, number|string>,
    start: number,
    last: number,
    intervals: {
        [key:string]:number}
    }


export const addTimingInterval = (timingRecord : TimingRecord , intervalName: string) => {
    const now = performance.now();
    timingRecord.intervals[intervalName] = now  - timingRecord.last;
    timingRecord.last = now;
}

export const newTimingRecord = (name:string, meta : Record<string, number|string> = {} ) : TimingRecord => {
    const now = performance.now();
    return {
        name,
        meta,
        start: now,
        last: now,
        intervals: {},
    }
}


